import { render, staticRenderFns } from "./ApForRecord.vue?vue&type=template&id=50ef4e38&"
import script from "./ApForRecord.vue?vue&type=script&lang=js&"
export * from "./ApForRecord.vue?vue&type=script&lang=js&"
import style0 from "./ApForRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ApForRecord.vue"
export default component.exports